import React, { useContext } from 'react';
import { Row, Col, Container } from 'reactstrap';
import { SessionContext } from '../../context/SessionContext';
import styles from './DealerInformation.module.css';
import BrandedIcon from '../../components/BrandingWhiteLabel/BrandedIcon';

const DealerInformation = () => {
    const sessionContext = useContext(SessionContext);
    const { accountName } = sessionContext;

    const DealerServiceInfo = ({ iconType, title, subTitle }) => {
        return (
            <Col
                md='12'
                lg='4'
                className={styles.benefitColumnContainer}
            >
                <BrandedIcon
                    accountName={accountName}
                    iconType={iconType}
                />
                <h5>{title}</h5>
                <h2>{subTitle}</h2>
                <hr />
                <p>
                    {iconType === 'differentpeople' && (
                        <>
                            <span>Outshine Competitor quotes</span> by adding the benefit of labor protection to help{' '}
                            <span>safeguard your customer's investment.</span>
                        </>
                    )}
                    {iconType === 'increaserevenue' && (
                        <>
                            Labor plans help you <span>earn more on every installation</span> and you choose your
                            preferred service reimbursement rate.
                        </>
                    )}
                    {iconType === 'satisfaction' && (
                        <>
                            Control the narrative; <span>be their hero</span> during a breakdown by helping{' '}
                            <span>reduce out-of-pocket expenses.</span>
                        </>
                    )}
                </p>
            </Col>
        );
    };

    return (
        <>
            <Row
                fluid
                className={styles.laborCoverageContainer}
            >
                <h1>A LABOR COVERAGE PROGRAM DESIGNED FOR SUCCESS</h1>
                <hr />
                <p>
                    We've created an extended service agreement program that will help you, our valued partner,{' '}
                    <span>grow your business and build long-term relationships with your customers.</span> A satisfied
                    customer will continue to work with you and refer their friends and family.{' '}
                    <span>Help your customers avoid out-of-pocket expenses</span> by pairing Nordyne Extended Service
                    Agreements with every installation.
                </p>
            </Row>
            <Row className={styles.benefitsContainer}>
                <DealerServiceInfo
                    iconType='differentpeople'
                    title='DIFFERENTIATE YOURSELF'
                    subTitle='BE COMPETITIVE'
                />
                <DealerServiceInfo
                    iconType='increaserevenue'
                    title='INCREASE YOUR REVENUE'
                    subTitle='GENERATE PROFIT'
                />
                <DealerServiceInfo
                    iconType='satisfaction'
                    title='CUSTOMER SATISFACTION'
                    subTitle='THANK YOU'
                />
            </Row>
        </>
    );
};

export default DealerInformation;
